module.exports = __webpack_public_path__ + "static/media/passwordGeneratorS.0e48141c.png";